import { render, staticRenderFns } from "./ProjectsFilterDialog.vue?vue&type=template&id=007ed355&scoped=true"
import script from "./ProjectsFilterDialog.vue?vue&type=script&lang=ts"
export * from "./ProjectsFilterDialog.vue?vue&type=script&lang=ts"
import style0 from "./ProjectsFilterDialog.vue?vue&type=style&index=0&id=007ed355&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007ed355",
  null
  
)

export default component.exports